<p-table id="ptable1" #ptable1
         [value]="lcoList"
         [rows]="10"
         [rowsPerPageOptions]="[10,25,50]"
         [loading]="loading"
         [showCurrentPageReport]="(totalRecords > 10)"
         [totalRecords]="totalRecords"
         [paginator]="(totalRecords > 10)"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} строк"
         sortMode="single"
         sortField="CLIENTSNIKNAME"
         dataKey="CLIID"
         selectionMode="single"
         [(selection)]="selectedRecord"
         [rowHover]="true"
         [resizableColumns]="true"
         styleClass=" p-datatable-gridlines p-datatable-striped">

  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn pSortableColumn="CLIENTSNIKNAME" style="width: 10% !important">Краткое название <p-sortIcon field="CLIENTSNIKNAME"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CLIENTSNAME" style="width: 20% !important">Полное наименование <p-sortIcon field="CLIENTSNAME"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CLIENTREGCODE" style="width: 5% !important">ЕДРПОУ<p-sortIcon field="CLIENTREGCODE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CLIENTVATREGCODE" style="width: 10% !important">Код НДС <p-sortIcon field="CLIENTVATREGCODE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CLIENTADDR1" style="width: 15% !important">Адрес <p-sortIcon field="CLIENTADDR1"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CLIENTADR2" style="width: 10% !important">Дполнительно <p-sortIcon field="CLIENTADR2"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CLIENTACCOUNT" style="width: 10% !important">Основной счет <p-sortIcon field="CLIENTACCOUNT"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CLIENTBANK2ACC" style="width: 10% !important">Дополнительный <p-sortIcon field="CLIENTBANK2ACC"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CLIENTNOTE1" style="width: 10% !important">Примечание <p-sortIcon field="CLIENTNOTE1"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CLIENTNOTE2" style="width: 10% !important">Примечание <p-sortIcon field="CLIENTNOTE2"></p-sortIcon></th>
    </tr>

    <tr>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CLIENTSNIKNAME']" (input)="ptable1.filter($event.target.value, 'CLIENTSNIKNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CLIENTSNAME']" (input)="ptable1.filter($event.target.value, 'CLIENTSNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CLIENTREGCODE']" (input)="ptable1.filter($event.target.value, 'CLIENTREGCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CLIENTVATREGCODE']" (input)="ptable1.filter($event.target.value, 'CLIENTVATREGCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CLIENTADDR1']" (input)="ptable1.filter($event.target.value, 'CLIENTADDR1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CLIENTADR2']" (input)="ptable1.filter($event.target.value, 'CLIENTADR2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CLIENTACCOUNT']" (input)="ptable1.filter($event.target.value, 'CLIENTACCOUNT', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CLIENTBANK2ACC']" (input)="ptable1.filter($event.target.value, 'CLIENTBANK2ACC', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CLIENTNOTE1']" (input)="ptable1.filter($event.target.value, 'CLIENTNOTE1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['CLIENTNOTE2']" (input)="ptable1.filter($event.target.value, 'CLIENTNOTE2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-recordsList>
    <tr [pSelectableRow]="recordsList">
      <td ><a [routerLink]="['/edit-client', recordsList.CLIID]">{{recordsList.CLIENTSNIKNAME}}</a></td>
      <td ><a [routerLink]="['/edit-client', recordsList.CLIID]">{{recordsList.CLIENTSNAME}}</a></td>
      <td >{{recordsList.CLIENTREGCODE}}</td>
      <td >{{recordsList.CLIENTVATREGCODE}}</td>
      <td >{{recordsList.CLIENTADDR1}}</td>
      <td >{{recordsList.CLIENTADR2}}</td>
      <td >{{recordsList.CLIENTACCOUNT}}</td>
      <td >{{recordsList.CLIENTBANK2ACC}}</td>
      <td >{{recordsList.CLIENTNOTE1}}</td>
      <td >{{recordsList.CLIENTNOTE2}}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10">У этой компании нет юридических лиц</td>
    </tr>
  </ng-template>
</p-table>
